/** @type {Styles} */

export const styles = {
  // this a style variable from from the library We cannot change its name
  cropperWrapper: {
    width: 'initial',
    height: '300px',
    position: 'relative',
    reactEasyCrop_Contain: {
      width: '100%',
      height: '100%',
    },
    '.cropper-container': {
      borderRadius: 2,
      overflow: 'hidden',
      height: 288,
      width: '100%',
      fontSize: 0,
      lineHeight: 0,
      position: 'relative',
      userSelect: 'none',
      img: {
        display: 'block',
        height: '100%',
        imageOrientation: '0deg',
        maxHeight: 'none',
        maxWidth: 'none',
        minHeight: 0,
        minWidth: 0,
        width: '100%',
      },
    },
    '.cropper-wrap-box': {
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      overflow: 'hidden',
    },
    '.cropper-canvas': {
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      overflow: 'hidden',
    },
    '.cropper-drag-box': {
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      backgroundColor: 'gray.0',
      opacity: 0,
    },
    '.cropper-crop-box': {
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      touchAction: 'none',
    },
    '.cropper-modal': {
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      opacity: 1,
      backgroundColor: 'overlays.default',
    },
    '.cropper-view-box': {
      display: 'block',
      height: '100%',
      overflow: 'hidden',
      width: '100%',
      ':before': {
        content: "' '",
        position: 'absolute',
        background: ({ palette }) =>
          `linear-gradient(to right, ${palette.primary.main} 4px, transparent 4px) 0 0, linear-gradient(to right, ${palette.primary.main} 4px, transparent 4px) 0 100%, linear-gradient(to left, ${palette.primary.main} 4px, transparent 4px) 100% 0, linear-gradient(to left, ${palette.primary.main} 4px, transparent 4px) 100% 100%, linear-gradient(to bottom, ${palette.primary.main} 4px, transparent 4px) 0 0, linear-gradient(to bottom, ${palette.primary.main} 4px, transparent 4px) 100% 0, linear-gradient(to top, ${palette.primary.main} 4px, transparent 4px) 0 100%, linear-gradient(to top, ${palette.primary.main} 4px, transparent 4px) 100% 100%`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '26px 26px',
        zIndex: 1,
        display: 'block',
        top: '-2px',
        bottom: '-2px',
        left: '-2px',
        right: '-2px',
        width: 'auto',
        height: 'auto',
      },
    },

    '.cropper-face': {
      display: 'block',
      height: '100%',
      opacity: 0.1,
      position: 'absolute',
      width: '100%',
      backgroundColor: 'gray.0',
      left: '0',
      top: '0',
    },
    '.cropper-line': {
      position: 'absolute',
      display: 'block',
      opacity: 0.1,
      height: '100%',
      width: '100%',
      '&.line-n, &.line-s, &.line-e, &.line-w': { display: 'none' },
    },
    '.cropper-point': {
      display: 'block',
      height: '30%',
      opacity: [0.1, 0.75],
      position: 'absolute',
      zIndex: 2,
      width: '30%',
      '&.point-e, &.point-s, &.point-n, &.point-w': { display: 'none' },
    },
    '.cropper-point.point-ne': {
      cursor: 'ne-resize',
      right: '-3px',
      top: '-3px',
    },
    '.cropper-point.point-nw': {
      cursor: 'nw-resize',
      left: '-3px',
      top: '-3px',
    },
    '.cropper-point.point-sw': {
      bottom: '-3px',
      cursor: 'sw-resize',
      left: '-3px',
    },
    '.cropper-point.point-se': {
      bottom: '-3px',
      cursor: 'se-resize',
      height: '30%',
      opacity: 1,
      right: '-3px',
      width: '30%',
    },
    '.cropper-invisible': {
      opacity: 0,
      zIndex: 2,
      height: 'auto',
      width: 'auto',
      top: ' 20%',
      bottom: '20%',
      left: '20%',
      right: '20%',
    },
    '.cropper-hide': {
      display: 'block',
      height: '0',
      position: 'absolute',
      width: '0',
    },

    '.cropper-hidden': { display: 'none' },
    '.cropper-move': { cursor: 'move' },
    '.cropper-crop': { cursor: 'crosshair' },
    '.cropper-disabled': {
      '.cropper-drag-box': { cursor: 'not-allowed' },
      '.cropper-face': { cursor: 'not-allowed' },
      '.cropper-line': { cursor: 'not-allowed' },
      '.cropper-point': { cursor: 'not-allowed' },
    },
  },
  avatarMask: {
    '.cropper-view-box': {
      outline: 2,
      outlineStyle: 'dashed',
      outlineColor: ({ palette }) => palette.gray[0],
      ':after': {
        content: "' '",
        position: 'absolute',
        inset: 0,
        border: 2,
        borderColor: 'primary.main',
        borderRadius: '50%',
      },
    },
  },
  cropperContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
  },
}
